import { lazy } from 'react'
// import Index from '../pages/index'
const Index = lazy(() => import('../pages/index/index'))
const Industries = lazy(() => import('../pages/Industries'))
const Product = lazy(()=> import('../pages/Product'))
const ContactUs = lazy(()=> import('../pages/ContactUs'))
const AboutUs = lazy(()=> import('../pages/AboutUs'))


const route = [
    {
        path: '/',
        key: 'Index',
        element: <Index/>,
    },
    {
        path: '/product',
        key: 'product',
        element: <Product/>,
    },
    {
        path: '/industries',
        key: 'Industries',
        element: <Industries/>,
    },
    {
        path: '/contact',
        key: 'contact',
        element: <ContactUs/>,
    },

    {
        path: '/about',
        key: 'AboutUs',
        element: <AboutUs/>,
    },
]
export default route;